import { Alert, Button, Checkbox, FormControlLabel, Link, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Controller, useForm } from "react-hook-form";
import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import useDocument from "../../hooks/useDocument";

const AnonymisedReferralForm = ({ handleOnCancel, handleOnSubmit, anonymisedReferral }) => {
    const { error } = useAuth();
    const { control, handleSubmit, reset } = useForm({
        reValidateMode: "onBlur"
    });
    const [ acknowledge, setAcknowledge ] = useState(false);
    const { getDocumentUrl } = useDocument();
    useEffect(() => {
        reset(anonymisedReferral);
        setAcknowledge(anonymisedReferral() && anonymisedReferral().anonymisedReferralAcknowledgement ? anonymisedReferral().anonymisedReferralAcknowledgement : false);
    },
    // eslint-disable-next-line
    [ anonymisedReferral ]);
    
    return (
        <Box
            component="form"
            onSubmit={handleSubmit(handleOnSubmit)}
            noValidate
            sx={{
                ml: 8,
                mr: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                width: '75ch',
                gap: 1,
            }}
        >
            {error && <Alert severity="error">{error}</Alert>}

            <Controller
                control={control}
                name="anonymisedReferralAcknowledgement"
                defaultValue={false}
                render={({ field, fieldState: { error } }) => (
                    <FormControlLabel
                        control={
                            <Checkbox
                                {...field}
                                size="small"
                                onChange={(e) => {field.onChange(e.target.checked); setAcknowledge(e.target.checked);}}
                                checked={field.value ? field.value : false}
                            />
                        }
                        label="By continuing you acknowledge that you are completing an anonymised referral. This form must not contain any personal information relating to the employee."
                    />
                )}
            />

            <Typography variant="p">
                Please fill in the{' '}
                <Link href={getDocumentUrl('PersonalParticularsForm-ORAMSAnonymisedReferral.docx')} target="_blank" rel="noreferrer">personal particulars form</Link>{' '}
                and email it to the relevant provider once you have completed the referral. Please use the ORAMS referral ID as reference when providing the personal particulars form.
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'left',
                    gap: 1,
                }}
            >
                <Button 
                    type="button"
                    variant="contained"
                    onClick={() => {
                        handleOnCancel();
                    }}
                >
                    Cancel
                </Button>
                <Button type="submit" variant="contained" disabled={!acknowledge}>Continue</Button>
            </Box>
        </Box>
    );
}

export default AnonymisedReferralForm;